module.exports = __webpack_public_path__ + "img/2022-04-05-00_00_00_LDZ_Seite_6-scaled.5f673dbc.jpg";